import { WarehouseOperations as Page } from './WarehouseOperations.main';
import { WarehouseOperationsHeader as Header } from './WarehouseOperationsHeader';

export { OperationsTable } from './OperationsTable';
export { Filters } from './Filters';

export const WarehouseOperations = { Header, Page };
